import pt from './pt.json';
import en from './en.json';
import es from './es.json';

export const translations = {
  'pt': pt,
  'en': en,
  'es': es,
};

export type LocaleKey = keyof typeof translations;